var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    d: "M14 8H0V0h14v8z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 8,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-179.999936 7 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.55850877 2.41633065C13.84280702 2.1499136 14 1.79579495 14 1.4186348c0-.37701615-.15719298-.73041474-.44149123-.99668781-.58686404-.55011517-1.5419956-.55011517-2.12978072-.00086404L7.17668861 4.39789747c-.09763158.09144587-.25574564.09144587-.35353072 0L2.57127195.42108295C1.9844079-.12816818 1.02835527-.12816818.44133773.42194699.1562719.68822006 0 1.04161865 0 1.4186348c0 .37716015.15627191.73127879.44133773.99769585l5.4931579 5.14386518C6.2197149 7.82747694 6.59765351 7.97479838 7 7.97479838c.40234648 0 .7802851-.14732144 1.06442984-.41460255l5.49407893-5.14386518"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/dropDownArrow.8849371dd49f27e7541991403715863a.svg";
export { ForwardRef as ReactComponent };